<canvas style="border: 2px solid black; background-color: green;" #formacionEquipo></canvas>